

const Authentication = function() {
};
Authentication.prototype.loginUrl = '/login/';
/**
 * Return the url for members to login, with the "redirect to" parameter set,
 * so that members are automatically returned to the current url once they've
 * logged in.
 */
Authentication.prototype.getLoginUrl = function() {
  var currentUrl = window.location.pathname + window.location.search;

  return this.loginUrl + '?redirect_to=' + encodeURIComponent(currentUrl);
};


const auth = new Authentication();


export default auth;

